import React, {useEffect, useState} from "react";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  ChartEvent,
  LegendItem,
  LegendElement,
  Chart,
  LineElement,
  CategoryScale, LinearScale, BarElement, Title, PointElement, type ChartOptions
} from 'chart.js';
import {Bar, Line, Pie} from 'react-chartjs-2';
import {ChartType} from "chart.js/dist/types";
import {ClipLoader} from "react-spinners";
import Select from "react-select";
import DateTimePicker from "react-datetime-picker";
import {apiConfig} from "../../../../../../config";
import axios from "axios";

ChartJS.register(
  ArcElement,
  PointElement,
  LineElement,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export const LineOptions = {
  responsive: true,
  plugins: {
    legend: {
      position: 'top' as const,
    },
    title: {
      display: false,
      text: 'Chart.js Line Chart',
    },
  },
};


const AllCallsStat = (props: any) => {
  const [allLeadsData, setAllLeadsData]: [any, any] = useState(null)
  const [selectOperator, setSelectOperator]: [any, any] = useState(null)
  const [selectProject, setSelectProject]: [any, any] = useState(null)
  const [selectProjectsAll, setSelectProjectsAll]: [any, any] = useState([])
  const [selectOperatorsAll, setSelectOperatorsAll]: [any, any] = useState([])

  const [isLoading, setIsLoading] = useState(false)

  const monthDate: any = (new Date())
  monthDate.setMonth(monthDate.getMonth() - 1);
  const [startDate, setStartDate]: [any, any] = useState(monthDate.setHours(0, 0, 0));

  const currentDate: any = (new Date())
  currentDate.setDate(currentDate.getDate() + 1);
  const [endDate, setEndDate]: [any, any] = useState(currentDate.setHours(0,0,0));

  const AllLeadsData = async () => {
    setIsLoading(true)

    let response_users = props.usersData
    let operatorsOptions = [
      {value: null, label: "Без оператора"}
    ]

    for (let i = 0; i < response_users.length; i++) {
      operatorsOptions.push(
        {value: response_users[i].id, label: response_users[i].name}
      )
    }
    setSelectOperatorsAll(operatorsOptions)

    let response_projects = props.projectsData
    let projectsOptions = [
      {value: null, label: "Без проекта"}
    ]

    for (let i = 0; i < response_projects.length; i++) {
      projectsOptions.push(
        {value: response_projects[i].id, label: response_projects[i].name}
      )
    }
    setSelectProjectsAll(projectsOptions)

    let tzoffset = (new Date()).getTimezoneOffset() * 60000;

    let startDateNormal = startDate ? (new Date(startDate - tzoffset)).toISOString() : null
    let endDateNormal = endDate ? (new Date(endDate - tzoffset)).toISOString() : null

    console.log(startDateNormal, endDateNormal)

    const config = {
      method: 'get',
      url: `${apiConfig.url}/statistic/dashboard/calls`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token_caltatToki')}`
      },
      params: {
        user_id: selectOperator ? selectOperator.value : null,
        project_id : selectProject ? selectProject.value : null,
        date_from: startDateNormal,
        date_to: endDateNormal,
      }
    };
    try {
      const response = await axios(config);

      let dataAllLeads = response.data.data

      console.log('CALLS RESPONSE', response.data)

      let leadsLabels = []
      let stacks0 = []
      let stacks1 = []

      let leads: any = []
      let calls_more_1_min: any = []
      let answered_calls: any = []
      let all_calls: any = []
      let proccessed_calls: any = []
      let ao_calls: any = []

      for (let i = 0; i < dataAllLeads.length; i++) {
        leadsLabels.push(
          dataAllLeads[i].created_at
        )

        leads.push(dataAllLeads[i].leads[0].leads);
        calls_more_1_min.push(dataAllLeads[i].leads[0].calls_more_1_min);
        answered_calls.push(dataAllLeads[i].leads[0].answered_calls)
        all_calls.push(dataAllLeads[i].leads[0].all_calls)
        proccessed_calls.push(dataAllLeads[i].leads[0].proccessed_calls)
        ao_calls.push(dataAllLeads[i].leads[0].ao_calls)
      }

      stacks0.push(
        {
          label: "Лиды",
          data: leads,
          backgroundColor: 'rgb(0, 255, 0)',
          borderColor: 'rgb(0, 255, 0)',
          pointRadius: 3,
          pointHoverRadius: 5,
        },
        {
          label: "Больше минуты звонки",
          data: calls_more_1_min,
          backgroundColor: 'rgb(211,197,21)',
          borderColor: 'rgb(211,197,21)',
          pointRadius: 3,
          pointHoverRadius: 5,
        },
        {
          label: "Клиент поднял трубку",
          data: answered_calls,
          backgroundColor: 'rgb(91,158,91)',
          borderColor: 'rgb(91,158,91)',
          pointRadius: 3,
          pointHoverRadius: 5,
        },
        {
          label: "Обработанные звонки",
          data: proccessed_calls,
          backgroundColor: 'rgb(103,255,103)',
          borderColor: 'rgb(103,255,103)',
          pointRadius: 3,
          pointHoverRadius: 5,
        },
        {
          label: "Все звонки",
          data: all_calls,
          backgroundColor: 'rgb(195,255,66)',
          borderColor: 'rgb(195,255,66)',
          pointRadius: 3,
          pointHoverRadius: 5,
        },
        {
          label: "Автоответчики/Тишина",
          data: ao_calls,
          backgroundColor: 'rgb(156,76,76)',
          borderColor: 'rgb(156,76,76)',
          pointRadius: 3,
          pointHoverRadius: 5,
        },
      )

      console.log(stacks0)

      let data = {
        labels: leadsLabels,
        datasets: stacks0
      }

      setAllLeadsData(data)

      setIsLoading(false)


    } catch (error) {
      console.error('error', error);
    }
  }


  useEffect(() => {
    AllLeadsData()
  }, [])

  return (
    <div style={{display: 'flex', flex: 1, flexDirection: 'column'}}>
      <div style={{display: "flex", flexDirection: "row", paddingTop: 20, paddingBottom: 20, alignItems: "center"}}>
        <div style={{display: "flex", flexDirection: "row", alignItems: "center", marginRight: 20}}>
          <div style={{marginRight: 10}}>
            Оператор:
          </div>
          <Select
            onChange={(item) => {
              setSelectOperator(item)
            }}
            options={selectOperatorsAll}
          />
        </div>
        <div style={{display: "flex", flexDirection: "row", alignItems: "center", marginRight: 20}}>
          <div style={{marginRight: 10}}>
            Проект:
          </div>
          <Select
            onChange={(item) => {
              setSelectProject(item)
            }}
            options={selectProjectsAll}
          />
        </div>
        <div style={{display: "flex", flexDirection: "row", alignItems: "center"}}>
          <div>
            Дата от:
          </div>

          <div style={{display: "flex", marginRight: 20, marginLeft: 10}}>
            <DateTimePicker
              onChange={(date: any) => {
                date ? setStartDate(new Date(date)) : setStartDate(null)
              }}
              value={startDate}
              disableClock={true}
            />
          </div>
          <div>
            Дата до:
          </div>
          <div style={{display: "flex", marginLeft: 10}}>
            <DateTimePicker
              onChange={(date: any) => {
                date ? setEndDate(new Date(date)) : setEndDate(null)
              }}
              value={endDate}
              disableClock={true}
            />
          </div>
        </div>
        <button
          onClick={() => {
            AllLeadsData()
          }}
          style={{
            display: "flex",
            height: 40,
            borderRadius: 5,
            justifyContent: "center",
            alignItems: 'center',
            borderWidth: 1,
            borderColor: "black",
            marginLeft: 60
          }}>
          Применить фильтр
        </button>
      </div>
      {!isLoading && allLeadsData && <Line style={{}} options={LineOptions} data={allLeadsData}/>}
      {isLoading && <div style={{
        fontSize: 30,
        minHeight: 700,
        width: "100%",
        height: "100%",
        // backgroundColor: "rgba(100, 100, 100, 0.2)",
        color: "white",
        display: "flex",
        justifyContent: "center",
        alignItems: 'center',
      }}>
          <ClipLoader size={150} color={"black"}/>
      </div>}
    </div>
  )
}

export default AllCallsStat
